//landing page header component
const LandingHeader = () => {
  return (
    <h1 className="landing-header-wrapper ">
      <span className="block">What does</span>
      <span className="landing-header-crafts">Crafts</span>
      <span className="block">Mean to You</span>
    </h1>
  );
};

export default LandingHeader;
